import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  table: {
    tableLayout: 'fixed'
  },
  tableCellWidth10: {
    width: '10rem'
  },
  tableCellWidth20: {
    width: '20rem'
  }
}));

export default useStyles;
